import React from 'react';
import { Link } from 'react-router-dom';
import './ChurchPage.css';

function ChurchCommitteePage() {
  return (
    <div className="dabia-church-page">
      {/* Church Header with Logo */}
      <div className="church-header">
        <div className="container">
          <Link to="/church" className="church-logo-link">
            <img src="/images/church-logo.png" alt="다비아샘터교회" className="church-logo" />
          </Link>
        </div>
      </div>

      {/* Top Banner */}
      <div className="top-banner">
        <p className="sola-text">Sola scriptura, Sola fide, Sola gratia</p>
      </div>

      {/* Church Navigation */}
      <nav className="church-navigation">
        <div className="container">
          <ul className="church-nav-menu">
            <li><Link to="/church">교회소개</Link></li>
            <li><Link to="/church/news">교회소식</Link></li>
            <li><Link to="/church/committee">운영위원회</Link></li>
            <li><Link to="/">다비아 메인</Link></li>
          </ul>
        </div>
      </nav>

      {/* Page Title */}
      <section className="page-title-section">
        <div className="container">
          <h1 className="page-title">운영위원회</h1>
        </div>
      </section>

      {/* Committee Content */}
      <div className="container main-content">
        <section className="committee-section">
          <div className="committee-intro">
            <p>
              다비아샘터교회 운영위원회는 교회의 주요 사안을 결정하고
              교회 공동체의 방향성을 함께 논의하는 기구입니다.
            </p>
          </div>

          <div className="committee-structure">
            <h2 className="section-title">운영위원회 구성</h2>

            <div className="committee-cards">
              <div className="committee-card">
                <h3>당회장</h3>
                <div className="member-info">
                  <p className="member-name">정용섭 목사</p>
                  <p className="member-role">담임목사 / 대구성서아카데미 원장</p>
                </div>
              </div>

              <div className="committee-card">
                <h3>장로</h3>
                <div className="member-info">
                  <p className="member-name">운영위원회 장로진</p>
                  <p className="member-role">교회 운영 및 목회 협력</p>
                </div>
              </div>

              <div className="committee-card">
                <h3>집사</h3>
                <div className="member-info">
                  <p className="member-name">운영위원회 집사진</p>
                  <p className="member-role">교회 실무 및 봉사</p>
                </div>
              </div>
            </div>
          </div>

          <div className="committee-role">
            <h2 className="section-title">주요 역할</h2>
            <ul className="role-list">
              <li>
                <strong>예배와 말씀 사역</strong>
                <p>주일 예배, 수요 기도회 등 예배 사역 계획 및 운영</p>
              </li>
              <li>
                <strong>재정 관리</strong>
                <p>교회 예산 편성, 집행, 결산 등 재정 관리 감독</p>
              </li>
              <li>
                <strong>교육 사역</strong>
                <p>성경 공부, 신앙 교육 프로그램 기획 및 운영</p>
              </li>
              <li>
                <strong>선교와 봉사</strong>
                <p>지역 사회 섬김과 선교 활동 계획 및 실행</p>
              </li>
              <li>
                <strong>교회 행정</strong>
                <p>교회 운영 전반에 관한 주요 사항 결정 및 집행</p>
              </li>
            </ul>
          </div>

          <div className="committee-meeting">
            <h2 className="section-title">회의 안내</h2>
            <div className="meeting-info-box">
              <div className="info-row">
                <span className="info-label">정기 회의</span>
                <span className="info-value">매월 첫째 주 주일 예배 후</span>
              </div>
              <div className="info-row">
                <span className="info-label">임시 회의</span>
                <span className="info-value">필요시 당회장 소집</span>
              </div>
              <div className="info-row">
                <span className="info-label">참석 대상</span>
                <span className="info-value">당회장, 장로, 집사</span>
              </div>
            </div>
          </div>

          <div className="committee-contact">
            <h2 className="section-title">문의</h2>
            <p>
              운영위원회 관련 문의사항이나 건의사항이 있으시면
              교회 사무실로 연락주시기 바랍니다.
            </p>
            <div className="contact-info">
              <p>
                <strong>전화:</strong> 010-8577-1227<br/>
                <strong>이메일:</strong> freude103801@hanmail.net
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Footer Links */}
      <section className="footer-links-section">
        <div className="container">
          <div className="footer-links">
            <a href="http://dabia.net" className="footer-link-btn" target="_blank" rel="noopener noreferrer">
              대구성서아카데미
            </a>
            <a href="/seoul-church" className="footer-link-btn">
              서울샘터교회
            </a>
            <a href="https://indiadabia.blogspot.com/" className="footer-link-btn" target="_blank" rel="noopener noreferrer">
              설교링크
            </a>
          </div>
        </div>
      </section>

      {/* Back to Top */}
      <button
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="맨 위로"
      >
        ↑
      </button>
    </div>
  );
}

export default ChurchCommitteePage;
